import React from 'react'
import {Field, reduxForm} from 'redux-form'
import FormDatePicker from '../../components/FormDatePicker';

import FlatButton from 'material-ui/FlatButton';

import 'flexboxgrid/css/flexboxgrid.css';


const validate = values => {
  const errors = {}
  const requiredFields = [
    'email',
    'password'
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })
  return errors
}

class SubHolidayForm extends React.Component {

  render() {

    const {
      auth,
      subHolidayId,
      workHolidayId,
      workHolidayMode,
      onClickAllDay,
      onClickHalfDay,
      onClickDelete,
      onClickClose,
      error, handleSubmit, 
    } = this.props

    return (

      <form>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        <div className="row">
          <div className="col-xs-4">

            <Field
              name="subHolidayDate"
              component={FormDatePicker}
              disabled={subHolidayId ? true : false}
              label="代休取得日"
            />

          </div>
        </div>

        <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>

          <FlatButton
            label="Cancel"
            primary={true}
            onTouchTap={onClickClose}
          />

          {subHolidayId &&
            <FlatButton
              label="削除"
              primary={true}
              onTouchTap={handleSubmit(onClickDelete(auth.id, workHolidayId, subHolidayId))}
            /> 
          }

          { !subHolidayId && 
            <FlatButton
              label="半休取得"
              primary={true}
              onTouchTap={handleSubmit(onClickHalfDay(auth.id, workHolidayId))}
            />
          }

          { !subHolidayId && workHolidayMode === 2 &&
            <FlatButton
              label="全休取得"
              primary={true}
              onTouchTap={handleSubmit(onClickAllDay(auth.id, workHolidayId))}
            />
          }


        </div>

      </form>

    )
  }
}

SubHolidayForm = reduxForm({
  form: 'subHolidayForm',
  validate
})(SubHolidayForm)


export default SubHolidayForm


// WEBPACK FOOTER //
// ./src/containers/forms/SubHolidayForm.js